import { IFormFieldType } from '@/widgets/create-widget'
import { MediaType } from '@/constants/constants'

const MobileAdStripSchema: { [key: string]: IFormFieldType } = {
  mobileAdStripSection: {
    type: 'Object',
    label: 'Mobile Ad Strip Section',
    required: false,
    children: {
      heading: {
        type: 'String',
        label: 'Heading',
        required: false,
      },
      subHeading: {
        type: 'String',
        label: 'Sub Heading',
        required: false,
      },
      mobileBanner: {
        type: 'Media',
        mediaTypes: [MediaType.IMAGE],
        label: 'Mobile Banner',
        required: false,
      },
      showPlaystore: {
        type: 'Boolean',
        label: 'Show Playstore',
        required: false,
      },
      playStoreUrl: {
        type: 'String',
        label: 'Play Store URL',
        required: false,
        dependencies: [
          {
            field: 'showPlaystore',
            value: true,
            rules: {
              required: true, // Keep it optional even when visible
              visible: true, // Custom rule for visibility
            },
          },
          {
            field: 'showPlaystore',
            value: false,
            rules: {
              visible: false, // Hide when enableReverseCountdown is false
            },
          },
        ],
      },
      showAppStore: {
        type: 'Boolean',
        label: 'Show App Store',
        required: false,
      },
      appStoreUrl: {
        type: 'String',
        label: 'App Store URL',
        required: false,
        dependencies: [
          {
            field: 'showAppStore',
            value: true,
            rules: {
              required: true, // Keep it optional even when visible
              visible: true, // Custom rule for visibility
            },
          },
          {
            field: 'showAppStore',
            value: false,
            rules: {
              visible: false, // Hide when enableReverseCountdown is false
            },
          },
        ],
      },
    },
  },
}

export default MobileAdStripSchema
export type MobileAdStripSectionProps = {
  heading: string
  subHeading: string
  mobileBanner: string
  showPlaystore: boolean
  playStoreUrl: string
  showAppStore: boolean
  appStoreUrl: string
}

export type MobileAdStripProps = {
  mobileAdStripSection: MobileAdStripSectionProps
}

export const MobileAdStripDefaultValues: MobileAdStripProps = {
  mobileAdStripSection: {
    heading: 'Learning At Your Pace Anytime, Anywhere',
    subHeading: "Download the CuriousJr App - India's Popular Learning Platform",
    showPlaystore: true,
    playStoreUrl: 'https://curiousjr.onelink.me/f96p/9kbj5v9u',
    showAppStore: false,
    appStoreUrl: '',
    mobileBanner: 'https://static.pw.live/production-curiousjr-fundoo/static/images/mobile-ad-strip.png',
  },
}
